import { render, staticRenderFns } from "./client-activity-anchor.vue?vue&type=template&id=664006d1"
import script from "./client-activity-anchor.vue?vue&type=script&lang=js"
export * from "./client-activity-anchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports